export default function hideElement({ isCoordinationGroup, serviceCase, groupId }) {
  return !isCoordinationGroup && groupId !== serviceCase.provider.id;
}
